@if (car && car.user) {
  <div class="listing-frame" [class.listing-sponsored]="isSponsered()">
    <span
      class="listing-legend"
      [class.listing-legend-hidden]="!isSponsered()"
      [attr.aria-hidden]="!isSponsered()"
    >
      {{ 'SPONSORED' | translate }}
    </span>
    <div
      class="card listing-card h-100 clickable-card cursor-poiner"
      role="link"
      tabindex="0"
      (keydown.enter)="$event.target === $event.currentTarget && goToDetails(car.id)"
      (click)="goToDetails(car.id)"
    >
      <!-- Carousel -->
      <car-images-carousel
        #images
        [displayLikeButton]="false"
        [listingCard]="true"
        [car]="car"
        [carouselId]="listId()"
      ></car-images-carousel>
      <!-- Card Body -->
      <div class="card-body">
        <div class="listing-title-row">
          <h5 class="card-title">
            <app-brand-logo [icon]="car.model"></app-brand-logo>{{ car.model }} - {{ car.name }}
            {{ car.year }}
            @if (car.status === statuses.Pending) {
              <span class="badge text-bg-warning">{{ car.status | translate }}</span>
            }
          </h5>
          @if (!car.isExpired && car.status !== statuses.Sold) {
            <button
              type="button"
              class="listing-favorite"
              [attr.aria-pressed]="images.isLiked()"
              [attr.aria-label]="
                (images.isLiked() ? 'REMOVE_FROM_FAVORITES' : 'ADD_TO_FAVORITES') | translate
              "
              (click)="images.toggleLike($event)"
              (keydown)="$event.stopPropagation()"
            >
              <i
                [class]="images.isLiked() ? 'bi bi-heart-fill' : 'bi bi-heart'"
                aria-hidden="true"
              ></i>
            </button>
          }
        </div>
        <div class="row">
          <div class="col-6">
            <p class="card-text">
              <i class="bi bi-speedometer px-1"></i>{{ car.kilometers | number: '1.0-0' }}
            </p>
          </div>
          <div class="col-6">
            <p class="card-text"><i class="bi bi-fuel-pump px-1"></i>{{ car.fuel | translate }}</p>
          </div>
          <div class="col-6">
            <p class="card-text">
              <span class="px-1"><img src="icons/gearbox.png" width="18" height="18" /></span
              >{{
                car.isManulaGear ? ('CAR_GEAR_MANUAL' | translate) : ('CAR_GEAR_AUTO' | translate)
              }}
            </p>
          </div>
          <div class="col-6">
            @if (car.city) {
              <p class="card-text">
                <i class="bi bi-geo-alt-fill px-1"></i>

                <span>{{ car.city | syrianCity }}<span class="px-1"></span></span>
              </p>
            }
          </div>
        </div>
      </div>
      <div class="card-footer text-body-secondary py-0">
        <div class="row">
          <div class="col-7">
            <p class="card-text small">
              <span class="px-1"
                ><img
                  loading="lazy"
                  [src]="'plans/' + car.user.plan + '.png'"
                  width="14"
                  height="15"
              /></span>
              <span>{{ car.user.name }}</span>
            </p>
          </div>
          <div class="col-5">
            <p class="card-text small">
              <i class="bi bi-clock-fill px-1"></i>{{ car.createdAt | date: 'dd.MM.yyyy' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
